// Messages from host to embedded:
//================================
export var EmbeddedHostEventType;
(function (EmbeddedHostEventType) {
    EmbeddedHostEventType["InitialConfiguration"] = "initialConfiguration";
    EmbeddedHostEventType["HostUpdate"] = "hostUpdate";
})(EmbeddedHostEventType || (EmbeddedHostEventType = {}));
// Messages from embedded to host:
//================================
export var EmbeddedScreenEventType;
(function (EmbeddedScreenEventType) {
    EmbeddedScreenEventType["OnLoad"] = "onLoad";
    EmbeddedScreenEventType["TaskUpdate"] = "taskUpdate";
    EmbeddedScreenEventType["OnExitReview"] = "onExitReview";
    EmbeddedScreenEventType["OnReviewComplete"] = "onReviewComplete";
})(EmbeddedScreenEventType || (EmbeddedScreenEventType = {}));
//# sourceMappingURL=ipc.js.map